import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`
export const Container = styled.div`
    display: flex;
    overflow: auto;
    margin-top: 1.5rem;
    padding: 0 1rem 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 0 1rem 0;
    }
`

export const MenuWrapper = styled.div`
    border: ${props => props.theme.typography.border.width.xxxThin}
        ${props => props.theme.typography.border.style.solid} ${props => props.theme.colors.tfwBlackOpacity10};
    border-radius: ${props => props.theme.typography.border.radius.xLarge};
    min-width: 9.75rem;
    margin-right: ${props => props.theme.spacing.xSmall};
    padding: ${props => props.theme.spacing.medium} 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-width: 10.5rem;
        margin-right: ${props => props.theme.spacing.medium};
        padding: ${props => props.theme.spacing.large} 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        min-width: 10.92rem;
        margin-right: ${props => props.theme.spacing.large};
        padding-bottom: ${props => props.theme.spacing.large};
    }
`

export const MenuContainer = styled.a`
    text-align: ${props => props.theme.style.textAlign.left};
    text-decoration: none;
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${props => props.theme.style.alignItems.baseline};
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.colors.tfwBlack87};
    cursor: pointer;
`

export const IconBox = styled.div`
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 9.375rem 9.375rem;
    margin: 0 ${props => props.theme.spacing.medium} ${props => props.theme.spacing.xxSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0 ${props => props.theme.spacing.large} ${props => props.theme.spacing.small};
    }
`

export const TitleSpan = styled.span`
    width: 75%;
    white-space: nowrap;
    display: ${props => props.theme.style.display.block};
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: 600;
    margin: 0 ${props => props.theme.spacing.medium};
    overflow: hidden;
    text-overflow: ellipsis;
    color: #282828;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1rem;
        margin: 0 ${props => props.theme.spacing.large};
    }
`

export const SubtitleSpan = styled.span`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-weight: 500;
    display: ${props => props.theme.style.display.block};
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.0125rem;
    color: #5f5f5f;
    margin-left: ${props => props.theme.spacing.medium};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 0.875rem;
        margin-left: ${props => props.theme.spacing.large};
    }
`
